import { Link } from 'react-router'
import type { Message } from '../../lib/types'
import { renderMessageText } from './helpers'

const ID = /^[A-Za-z0-9_-]{1,80}$/

export function TextoMensaje({ mensaje, projectId, names }: {
  mensaje: Message
  projectId?: string
  names: Map<string, string>
}) {
  const archivos = projectId && ID.test(projectId) && mensaje.importado?.sistema === 'basecamp'
    ? (mensaje.archivos ?? []).filter((a) => ID.test(a.id))
    : []
  // El nombre sigue en el texto guardado para el inbox y las versiones anteriores de la app.
  const nombres = new Set(archivos.map((a) => `📎 ${a.nombre}`))
  const texto = mensaje.text.split('\n').filter((linea) => !nombres.has(linea.trim())).join('\n')

  return <>
    {texto && <div className="chat-text">{renderMessageText(texto, mensaje.mentions, names)}</div>}
    {archivos.length > 0 && <div className="chat-files">
      {archivos.map((a) => <Link key={a.id} to={`/p/${projectId}/archivos?archivo=${a.id}`} aria-label={`Abrir ${a.nombre}`}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" aria-hidden="true">
          <path d="m8 12 6-6a3 3 0 0 1 4 4l-8 8a5 5 0 0 1-7-7l8-8" />
        </svg>
        <span>{a.nombre}</span>
      </Link>)}
    </div>}
  </>
}
